import axios, { AxiosError, AxiosResponse } from 'axios';

import { SignupHttpError, SignupValidationHttpError } from './signup.types';

export type OmaSATOApiErrorData<T = string> = {
  errorId: T | null;
  message: string | null;
  details: string | null;
  dataSourceId: string | null;
  metadata: string | null;
  debugData: string | null;
};

export interface OmaSATOApiError<T = string>
  extends Omit<AxiosError<OmaSATOApiErrorData<T>>, 'response'> {
  response: AxiosResponse<OmaSATOApiErrorData<T>>;
}

export function isOmaSATOApiError(error: unknown): error is OmaSATOApiError {
  if (axios.isAxiosError(error)) {
    const castedError: AxiosError<any> = error;

    if (castedError.response) {
      return castedError.response.data.errorId !== undefined;
    }
  }
  return false;
}

export type SignupApiError = OmaSATOApiError<SignupHttpError>;
export type SignupValidationApiError =
  OmaSATOApiError<SignupValidationHttpError>;
